import { z } from "zod";
import { PaginationSchema } from "../../pagination/response/PaginationResponse";
import { CompanySchema } from "../../company/response/IndexCompanyResponse";
import { PropertySchema } from '../../properties/response/PropertyBaseSchema';


/**
 * Mendefinisikan skema Zod minimal untuk objek User.
 * Ini digunakan untuk memvalidasi data pengguna yang mungkin disertakan
 * dalam relasi 'users'.
 */
const UserSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    email: z.string().email(),
    // Tambahkan field lain dari user jika diperlukan
});

/**
 * Skema utama untuk satu objek Group.
 * Ini mendefinisikan semua field yang diharapkan dari API untuk satu grup,
 * termasuk relasi opsional yang bisa dimuat dengan parameter 'include'.
 */
export const GroupSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    channex_id: z.string().nullable(),
    description: z.string().nullable(),
    company_id: z.string().uuid(),
    is_editable: z.boolean().optional(),
    created_at: z.string().datetime("Invalid datetime format for created_at"),
    updated_at: z.string().datetime("Invalid datetime format for updated_at"),

    // --- Relasi Opsional ---
    // Properti ini hanya akan ada jika 'include=company' digunakan dalam request.
    // Menggunakan kembali CompanySchema untuk konsistensi.
    company: z.nullable(CompanySchema).optional(),

    // Properti ini hanya akan ada jika 'include=users' digunakan dalam request.
    users: z.array(UserSchema).optional(),
    properties: z.lazy(() => z.array(PropertySchema).optional()),
});

/**
 * Skema untuk keseluruhan respons dari endpoint GET /group.
 * Ini mencakup wrapper standar (success, message, code), array data
 * yang divalidasi dengan GroupSchema, dan objek paginasi opsional.
 */
export const GroupResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number().int(),
    data: z.array(GroupSchema),
    pagination: z.nullable(PaginationSchema).optional(),
});

// Mengekspor tipe data TypeScript yang di-infer dari skema Zod.
// Ini sangat penting untuk type safety di seluruh aplikasi saat bekerja
// dengan data grup.
export type GroupResponse = z.infer<typeof GroupResponseSchema>;
export type GroupData = z.infer<typeof GroupSchema>;